import { render, staticRenderFns } from "./_base-dropdown-picker.vue?vue&type=template&id=bafffdae&scoped=true&"
import script from "./_base-dropdown-picker.vue?vue&type=script&lang=js&"
export * from "./_base-dropdown-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-dropdown-picker.vue?vue&type=style&index=0&id=bafffdae&prod&lang=less&"
import style1 from "./_base-dropdown-picker.vue?vue&type=style&index=1&id=bafffdae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafffdae",
  null
  
)

export default component.exports